(function (theme, document, window) {
    "use strict";

    theme = window.theme = window.theme || {};
    theme.utils = theme.utils || {};

    // Simple debounce (Shopify-style util)
    theme.utils.debounce =
        theme.utils.debounce ||
        function (func, wait) {
            var timeout;
            return function () {
                var context = this,
                    args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(function () {
                    func.apply(context, args);
                }, wait);
            };
        };

    // Component constructor
    function BreadcrumbsCollapser(root) {
        this.root = root; // <ol class="breadcrumbs__list">
        this.originalHTML = root.innerHTML;
        this.boundOnResize = theme.utils.debounce(this.update.bind(this), 150);
        this.update(); // initial pass
        window.addEventListener("resize", this.boundOnResize);
    }

    BreadcrumbsCollapser.prototype.destroy = function () {
        window.removeEventListener("resize", this.boundOnResize);
        this.root.innerHTML = this.originalHTML;
    };

    BreadcrumbsCollapser.prototype._totalItemsWidth = function () {
        var items = this.root.querySelectorAll(".breadcrumbs__item");
        var total = 0;
        for (var i = 0; i < items.length; i++) {
            var li = items[i];
            var rect = li.getBoundingClientRect();
            var styles = window.getComputedStyle(li);
            var marginX =
                parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
            total += rect.width + marginX;
        }
        return total;
    };

    BreadcrumbsCollapser.prototype.update = function () {
        // Always start from pristine markup before any measurement/manipulation
        this.root.innerHTML = this.originalHTML;

        // Mobile-only behavior (tweak breakpoint if needed)
        var isMobile = window.innerWidth < 768;
        if (!isMobile) return;

        var items = this.root.querySelectorAll(".breadcrumbs__item");
        if (items.length < 3) return;

        // Measure after layout is stable
        var self = this;
        window.requestAnimationFrame(function () {
            var totalWidth = self._totalItemsWidth();
            var containerWidth = self.root.clientWidth;
            if (totalWidth <= containerWidth + 1) {
                // Fits — leave full trail
                self.root.innerHTML = self.originalHTML;
                return;
            }

            // Collapse: keep first + last, replace middle with "..."
            var freshItems = self.root.querySelectorAll(".breadcrumbs__item");
            for (var i = 1; i < freshItems.length - 1; i++) {
                freshItems[i].parentNode.removeChild(freshItems[i]);
            }
            var ellipsis = document.createElement("li");
            ellipsis.className = "breadcrumbs__item";
            ellipsis.innerHTML = '<span class="breadcrumbs__link">...</span>';
            var firstItem = self.root.querySelectorAll(".breadcrumbs__item")[0];
            if (firstItem && firstItem.nextSibling) {
                firstItem.parentNode.insertBefore(
                    ellipsis,
                    firstItem.nextSibling
                );
            } else if (firstItem) {
                firstItem.parentNode.appendChild(ellipsis);
            }
        });
    };

    // Registry
    theme.Breadcrumbs = {
        instances: [],
        init: function (container) {
            var scope = container || document;
            var lists = scope.querySelectorAll(".breadcrumbs__list");
            for (var i = 0; i < lists.length; i++) {
                // Avoid double-initialization (attach marker)
                if (lists[i].hasAttribute("data-bc-init")) continue;
                lists[i].setAttribute("data-bc-init", "true");
                this.instances.push(new BreadcrumbsCollapser(lists[i]));
            }
        },
        unload: function (container) {
            // Destroy instances only inside container (Theme Editor support)
            var scope = container || document;
            for (var i = this.instances.length - 1; i >= 0; i--) {
                var inst = this.instances[i];
                if (!scope.contains(inst.root)) continue;
                inst.destroy();
                this.instances.splice(i, 1);
            }
        }
    };

    // Boot on DOM ready (storefront)
    document.addEventListener("DOMContentLoaded", function () {
        theme.Breadcrumbs.init(document);
    });

    // Theme Editor events
    document.addEventListener("shopify:section:load", function (evt) {
        theme.Breadcrumbs.init(evt.target);
    });
    document.addEventListener("shopify:section:unload", function (evt) {
        theme.Breadcrumbs.unload(evt.target);
    });
    document.addEventListener("shopify:section:select", function (evt) {
        theme.Breadcrumbs.init(evt.target);
    });
})(window.theme, document, window);
